import { z } from 'zod';

import { PlanCodeZod } from 'types/zod/plan-code';

export const UserPlanZod = z
    .object({
        plan_code: PlanCodeZod,
        plan_expiration_date: z.number(),
        plan_start_date: z.number(),
        subscription: z.string(),
        user_plan_id: z.number(),
    })
    .partial();

export type UserPlan = z.infer<typeof UserPlanZod>;
